"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.tags.placeholder': 'Wprowadź tagi oddzielone przecinkami',
    'knowledge.tags.help': 'Naciśnij Enter, aby dodać każdy tag',
};
